import { render, staticRenderFns } from "./AgentDetailPopover.vue?vue&type=template&id=055a3890&scoped=true"
import script from "./AgentDetailPopover.vue?vue&type=script&lang=js"
export * from "./AgentDetailPopover.vue?vue&type=script&lang=js"
import style0 from "./AgentDetailPopover.vue?vue&type=style&index=0&id=055a3890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a3890",
  null
  
)

export default component.exports